export const environment = {
  production: false,
  local: false,
  apiBaseUrl: 'https://booking-dev.nsaitalia.eu/api'
};
